export default "__VITE_ASSET__BA49V8gw__"